export const GetTotalsUnivers = (park) => {
    let total = 0;
    try {
        total = park[0] ? park[0].univers.length + park[1].univers.length : 0;
    } catch (e) {
        console.log(e);
    }
    return total;
}